import React, { useEffect,  Component } from 'react'
import { Provider } from 'react-redux'
import configureStore from '../store/configureStore'
import { createBrowserHistory } from 'history'
import { startListener } from '../utils/routerListener'

import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import "firebase/compat/storage"
import 'firebase/compat/functions'

import { ReactReduxFirebaseProvider, useFirestore } from 'react-redux-firebase'
import { createFirestoreInstance} from 'redux-firestore' // <- needed if using firestore
import { useSelector, useDispatch } from 'react-redux'
import { isLoaded, isEmpty } from 'react-redux-firebase'
import * as ConfigActions from '../actions/ConfigActions';

import { default as Login } from './LoginApp.js'

const history = createBrowserHistory()
const store = configureStore(null, history)
import {env} from '../constants/Environment';

startListener(history, store)

const fbConfig = {
    apiKey: "AIzaSyAn-OISZUk3HYAX9Cnh7Fq8z51A1ltp6x0",
    authDomain: "oddset-cloud.firebaseapp.com",
    databaseURL: "https://oddset-cloud.firebaseio.com",
    projectId: "oddset-cloud",
    storageBucket: "oddset-cloud-" + env,
    messagingSenderId: "16751398936",
    appId: "1:16751398936:web:3bc543a27e1a7e6536b36d",
    measurementId: "G-E8LE6PN0PT",
    region: 'europe-west1'
}

// react-redux-firebase config
const rrfConfig = {
  userProfile: 'environments/' + env + '/users',
  useFirestoreForProfile: true, // Firestore for Profile instead of Realtime DB
  useFirestoreForStorageMeta: true
}

let fireApp = firebase.initializeApp(fbConfig)
firebase.firestore();
fireApp.functions('europe-west1');

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
}

function AuthIsLoaded({ children }) {
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const isFirestoreInStore = useSelector(({config}) => config.firestore !== null);

    const auth = useSelector(state => state.firebase.auth)

    useEffect(() => {
        if(isLoaded(auth) && !isEmpty(auth) && firestore !== null)
            dispatch(ConfigActions.set('firestore', firestore));
    }, [firestore, isLoaded(auth), !isEmpty(auth)])

    if (!isLoaded(auth) || isEmpty(auth) || !isFirestoreInStore)
        return <Login />;
    return children
}

export default class App extends Component {
  render () {
    return (
	      <Provider store={store}>
            <ReactReduxFirebaseProvider {...rrfProps}>
	          <div>
	            <div>
                    <AuthIsLoaded>
	            	{React.cloneElement(this.props.children)}            
                    </AuthIsLoaded>
	            </div>
	          </div>
            </ReactReduxFirebaseProvider>
	      </Provider>
    )
  }
}